module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"br":{"next":"Próxima","prev":"Anterior"},"en":{"next":"Next","prev":"Previous"},"es":{"next":"Próximo","prev":"Anterior"}}')
  delete Component.options._Ctor
}
